import {Category} from "../../category/category";
import {Rooftop} from "../../rooftop";
import { Stats } from "../../stats/stats";
import { Week } from "../../category/week";
export class responseRtbData {
    categories:Array<Category>;
    mediaCategories: Array<string>;
    rooftops: Array<Rooftop>;
    stats: Stats;
    weeks: Array<Week>;
    constructor (categories,mediaCategories,rooftops,stats,weeks) {
        this.categories = categories.map(item => new Category(item));
        this.mediaCategories = mediaCategories;
        this.rooftops = rooftops.map(item => new Rooftop(item));
        this.stats = new Stats(stats);
        if (weeks) {
            this.weeks = weeks.map(item => new Week(item));
        }
        
    }
}


// WEBPACK FOOTER //
// ./src/app/components/class/http/res/response-rtb-data.ts